/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useRef, useEffect, useState } from 'react'
import { useGLTF } from '@react-three/drei'
import * as THREE from 'three'
import { useThree, extend, Canvas, useFrame, Renderer } from '@react-three/fiber'

import { computeBoundsTree, disposeBoundsTree, acceleratedRaycast, CONTAINED, INTERSECTED, NOT_INTERSECTED } from 'three-mesh-bvh';
THREE.Mesh.prototype.raycast = acceleratedRaycast;
THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;

const RADIUS = 0.7;

export default function Model(props) {
  const mesh = useRef()
  const group = useRef()
  const brushMesh = useRef()

  const { nodes } = useGLTF('/hand.glb')

  var mouse = useRef(new THREE.Vector2(0, 0))

  // var [brushActive, setBrushActive] = useState(false);
  const brushActive = useRef()
  var [mouseType, setMouseType] = useState(-1);
  var [clearing, setClearing] = useState(false);
  const camera = useThree((state) => state.camera);
  const scene = useThree((state) => state.scene);

  useFrame(() => {
    if (mesh.current == null || brushMesh.current == null) {
      return;
    }

    const geometry = mesh.current.geometry;
    const bvh = geometry.boundsTree;
    const colorAttr = geometry.getAttribute('color');
    const indexAttr = geometry.index;
    if (clearing) {
      for (let i = 0; i < 1000; i++) {
        let n = getRandomInt(colorAttr.count);
        colorAttr.setX(n, 255);
        colorAttr.setY(n, 255);
        colorAttr.setZ(n, 255);
        colorAttr.needsUpdate = true;
      }
    }

    if (!brushActive.current) {
      brushMesh.current.visible = false;

    } else {
      brushMesh.current.scale.setScalar(RADIUS);

      const raycaster = new THREE.Raycaster();
      raycaster.setFromCamera(mouse.current, camera);
      raycaster.firstHitOnly = true;

      const res = raycaster.intersectObject(mesh.current, true);
      if (res.length) {
        brushMesh.current.position.copy(res[0].point);
        // controls.enabled = false;
        brushMesh.current.visible = true;

        const inverseMatrix = new THREE.Matrix4();
        inverseMatrix.copy(mesh.current.matrixWorld).invert();
        const sphere = new THREE.Sphere();
        sphere.center.copy(brushMesh.current.position).applyMatrix4(inverseMatrix);
        sphere.radius = RADIUS;

        const indices = [];
        const tempVec = new THREE.Vector3();
        bvh.shapecast({
          intersectsBounds: box => {
            const intersects = sphere.intersectsBox(box);
            const { min, max } = box;
            if (intersects) {
              for (let x = 0; x <= 1; x++) {
                for (let y = 0; y <= 1; y++) {
                  for (let z = 0; z <= 1; z++) {
                    tempVec.set(
                      x === 0 ? min.x : max.x,
                      y === 0 ? min.y : max.y,
                      z === 0 ? min.z : max.z
                    );
                    if (!sphere.containsPoint(tempVec)) {
                      return INTERSECTED;
                    }
                  }
                }
              }
              return CONTAINED;
            }
            return intersects ? INTERSECTED : NOT_INTERSECTED;
          },

          intersectsTriangle: (tri, i, contained) => {
            if (contained || tri.intersectsSphere(sphere)) {
              const i3 = 3 * i;
              indices.push(i3, i3 + 1, i3 + 2);
            }
            return false;
          }
        });

        if (mouseType === 0 || mouseType === 2) {
          let r = 255, g = 255, b = 255;
          if (mouseType === 0) {
            r = 0;
            g = 0;
            b = 255;
          }
          for (let i = 0, l = indices.length; i < l; i++) {
            const i2 = indexAttr.getX(indices[i]);
            colorAttr.setX(i2, r);
            colorAttr.setY(i2, g);
            colorAttr.setZ(i2, b);
          }
          colorAttr.needsUpdate = true;
        }
      } else {
        brushMesh.current.visible = false;
      }
    }

    var i = 0.01;
    group.current.rotation.x = group.current.rotation.y += i;
  })

  function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const geometry = mesh.current.geometry;
      const colorAttr = geometry.getAttribute('color');

      let count = 0;
      for (let i = 0; i < colorAttr.count; i++) {
        if (colorAttr.getX(i) == 0) {
          count++;
        }
      }

      if (count >= 50300 && clearing == false) {
        setClearing(true);
      }

      if (count < 200 && clearing == true) {
        setClearing(false);
      }
      const arr =  Array.from(colorAttr.array);
      localStorage.setItem("hand", JSON.stringify(arr))
      // console.log(`count ${ colorAttr.count}`);
    }, 1000);
    return () => clearInterval(interval);
  })

  useEffect(() => {
    const geometry = mesh.current.geometry;
    geometry.computeBoundsTree();
    const colorArray = new Uint8Array(geometry.attributes.position.count * 3);
    colorArray.fill(255);
    let colorAttr = new THREE.BufferAttribute(colorArray, 3, true);
    colorAttr.setUsage(THREE.DynamicDrawUsage);



    // for (let i = 0; i < colorAttr.count; i++) {
    //   colorAttr.setX(i, getRandomInt(255));
    //   colorAttr.setY(i, getRandomInt(255));
    //   colorAttr.setZ(i, getRandomInt(255));
    // }
    try {

      const retrievedArray = Uint8Array.from(JSON.parse(localStorage.getItem("hand")));
      colorAttr = new THREE.BufferAttribute(retrievedArray, 3, true);
    } catch (e) {
      console.log("failed to parse");
    }

    geometry.setAttribute('color', colorAttr);

    const material = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.85, metalness: 0, vertexColors: true });
    mesh.current.material = material;

    brushActive.current = false;

    window.addEventListener('pointerdown', function (e) {
      mouse.current =
        new THREE.Vector2(
          (e.clientX / window.innerWidth) * 2 - 1,
          -(e.clientY / window.innerHeight) * 2 + 1);
      setMouseType(e.button);

      // disable the controls early if we're over the object because on touch screens
      // we're not constantly tracking where the cursor is.
      const raycaster = new THREE.Raycaster();
      raycaster.setFromCamera(mouse, camera);
      raycaster.firstHitOnly = true;

      const res = raycaster.intersectObject(group.current, true);
      brushActive.current = true;
      // controls.enabled = res.length === 0;
    }, true);

    window.addEventListener('pointermove', function (e) {
      mouse.current =
        new THREE.Vector2(
          (e.clientX / window.innerWidth) * 2 - 1,
          -(e.clientY / window.innerHeight) * 2 + 1);
      brushActive.current = true;
    });

    window.addEventListener('pointerup', function (e) {
      setMouseType(-1);
      if (e.pointerType === 'touch') {
        brushActive.current = false;
      }
    }, true);

    const brushGeometry = new THREE.SphereBufferGeometry(1, 40, 40);
    const brushMaterial = new THREE.MeshStandardMaterial({
      color: 0x0000ff,
      roughness: 1.0,
      metalness: 0,
      transparent: true,
      opacity: 0.2,
      premultipliedAlpha: true,
      emissive: 0x0000bb,
      emissiveIntensity: 0,
    });

    brushMesh.current = new THREE.Mesh(brushGeometry, brushMaterial);
    scene.add(brushMesh.current);

  }, []);


  return (
    <group ref={group} {...props} rotation={[Math.PI / 2, 0, 0]}>
      <mesh ref={mesh}
        geometry={nodes['11537_Hand_v3'].geometry}
      // layers={2}
      >
        {/* <meshStandardMaterial color={'white'} /> */}
      </mesh>
    </group>
  )
}

useGLTF.preload('/hand.glb')
